import { render, staticRenderFns } from "./interviewMsg.vue?vue&type=template&id=c959e3b4&scoped=true"
import script from "./interviewMsg.vue?vue&type=script&lang=js"
export * from "./interviewMsg.vue?vue&type=script&lang=js"
import style0 from "./interviewMsg.vue?vue&type=style&index=0&id=c959e3b4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c959e3b4",
  null
  
)

export default component.exports